<script setup lang="ts">
import XOverlay, { Transitions } from "@Modules/shared/store/XOverlay";

const overlay = XOverlay();
</script>

<template>
  <transition
    :name="overlay.transition"
    @after-leave="overlay.setTransition(Transitions.Pop)"
  >
    <component
      :is="overlay.activeComponent"
      v-if="overlay.activeComponent"
      v-bind="overlay.props"
      v-on="overlay.events"
    />
  </transition>
</template>